const PiggyBankIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.0833 7.08329C11.4327 6.91463 10.5286 6.66663 9.80386 6.66663C6.23028 6.66663 3.33331 8.88966 3.33331 11.6319C3.33331 13.2077 4.28993 14.6121 5.78185 15.5217L5.41674 16.7259C5.29991 17.1112 5.58828 17.5 5.99093 17.5H7.29286C7.42274 17.5 7.54911 17.4578 7.653 17.3799L8.78847 16.5277H10.8193L11.9547 17.3799C12.0586 17.4578 12.185 17.5 12.3149 17.5H13.6168C14.0194 17.5 14.3078 17.1112 14.191 16.7259L13.8259 15.5217C14.7147 14.9798 15.4136 14.2622 15.8333 13.4375"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0833 7.08337L15.8333 5.83337L15.7633 8.85696L17.5 9.58337V12.5L15.8951 13.3334"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.9166 10.8333C12.6865 10.8333 12.5 10.6468 12.5 10.4167C12.5 10.1865 12.6865 10 12.9166 10C13.1468 10 13.3333 10.1865 13.3333 10.4167C13.3333 10.6468 13.1468 10.8333 12.9166 10.8333Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66669 8.33337C1.66669 8.33337 1.66669 10.3334 3.33335 10.8334"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6674 6.4608C10.7748 6.15109 10.8333 5.8178 10.8333 5.4706C10.8333 3.82998 9.5275 2.5 7.91667 2.5C6.30584 2.5 5 3.82998 5 5.4706C5 6.25531 5.29874 6.96896 5.7867 7.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export default PiggyBankIcon;
